export default __webpack_public_path__ + "static/media/D042.838f45eb.jpg";